import type { TournatedFeeVat } from "@/types";

import type { EntityFeeVatFormValues, FeeVatFormValues } from "./FeesForm.types";

/** The VAT columns every level's PATCH body shares (platform / league / entity map value). */
export type TournatedFeeVatInput = {
  isTournatedFeeVatEnable: boolean;
  tournatedFeeVat?: number | null;
};

/** VAT off with no stored rate — the state of a level that never configured VAT. */
export const makeDefaultFeeVatFormValues = (): FeeVatFormValues => ({
  isEnabled: false,
  rate: null,
});

/** Domain VAT → editor state. */
export const mapTournatedFeeVatToFormValues = (vat: TournatedFeeVat): FeeVatFormValues => ({
  isEnabled: vat.isEnabled,
  rate: vat.rate,
});

/**
 * An entity's own VAT on one platform → editor state. A platform with no entry
 * inherits the platform's VAT.
 */
export const mapEntityTournatedFeeVatToFormValues = (
  vat: TournatedFeeVat | undefined
): EntityFeeVatFormValues =>
  vat
    ? { inherit: false, ...mapTournatedFeeVatToFormValues(vat) }
    : { inherit: true, ...makeDefaultFeeVatFormValues() };

/** A cleared number input reads as `NaN`; the wire only knows a number or `null`. */
const toSentRate = (rate: number | null): number | null =>
  typeof rate === "number" && Number.isFinite(rate) ? rate : null;

/**
 * Editor state → the VAT columns of a PATCH body.
 *
 * VAT on the Tournated fee (switch and rate) is Tournated-admin-only on every
 * level: callers send these keys only for a super admin; anyone else sends no
 * VAT key at all and the stored VAT is kept.
 */
export const mapFeeVatFormValuesToInput = (values: FeeVatFormValues): TournatedFeeVatInput => ({
  isTournatedFeeVatEnable: values.isEnabled,
  tournatedFeeVat: toSentRate(values.rate),
});
